// @react/hooks/useFiscalizationFiscalReceipt.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { fiscalizationFiscalReceiptStore } from '@core/stores';

/**
 * React hook for FiscalReceipt operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useFiscalizationFiscalReceipt } from '@react/hooks';
 *
 * const FiscalReceiptList = observer(() => {
 *   const store = useFiscalizationFiscalReceipt();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useFiscalizationFiscalReceipt() {
  return fiscalizationFiscalReceiptStore;
}
